import axios from "axios";
import swal from "sweetalert";
import { loginConfirmedAction, Logout } from "../store/actions/AuthActions";
import { post } from "../jsx/helpers/api_helper";
import {
  POST_HealthCheck,
  POST_LOGIN,
  POST_Logout,
  POST_RevokeToken,
} from "../jsx/helpers/url_helper";

export function signUp(email, password) {
  //axios call
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    postData
  );
}

export function login(email, password) {
  const postData = {
    email,
    password,
    returnSecureToken: true,
  };
  return axios.post(
    `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
    postData
  );
}

export function formatError(errorResponse) {
  switch (errorResponse.error.message) {
    case "EMAIL_EXISTS":
      swal("Oops", "Email already exists", "error");
      break;
    case "EMAIL_NOT_FOUND":
      swal("Oops", "Email not found", "error", { button: "Try Again!" });
      break;
    case "INVALID_PASSWORD":
      swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
      break;
    case "USER_DISABLED":
      return "User Disabled";

    default:
      return "";
  }
}

export function saveTokenInLocalStorage(tokenDetails) {
  tokenDetails.expireDate = new Date(
    new Date().getTime() + tokenDetails.expiresIn * 1000
  );
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}

export function runLogoutTimer(dispatch, timer, navigate) {
  /*disable runout timer by Hitesh Vaghela*/
  //   setTimeout(() => {
  //     //dispatch(Logout(history));
  //     dispatch(Logout(navigate));
  //   }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
  // const tokenDetailsString = localStorage.getItem('userDetails');
  // let tokenDetails = '';
  // if (!tokenDetailsString) {
  //     dispatch(Logout(navigate));
  // 	return;
  // }

  // tokenDetails = JSON.parse(tokenDetailsString);
  // let expireDate = new Date(tokenDetails.expireDate);
  // let todaysDate = new Date();

  // if (todaysDate > expireDate) {
  //     dispatch(Logout(navigate));
  //     return;
  // }

  // dispatch(loginConfirmedAction(tokenDetails));

  // const timer = expireDate.getTime() - todaysDate.getTime();
  // runLogoutTimer(dispatch, timer, navigate);

  const authUserDetail = localStorage.getItem("userDetails");
  if (!authUserDetail) {
    dispatch(Logout(navigate));
    return;
  }
  dispatch(loginConfirmedAction(JSON.parse(authUserDetail)));
}

export function isLogin() {
  const tokenDetailsString = localStorage.getItem("userDetails");

  if (tokenDetailsString) {
    return true;
  } else {
    return false;
  }
}

export function login_user(UserName, Password) {
  let fcmToken = localStorage.getItem("FCMToken");
  const postData = {
    UserName,
    Password,
    DeviceType: 1, //web
    FCMToken: fcmToken ? fcmToken : "",
  };

  return post(POST_LOGIN, postData);
}

export function revoke_token(refreshToken) {
  return post(POST_RevokeToken, {
    RefreshToken: refreshToken,
  });
}

export function user_logout(LoginID) {
  return post(POST_Logout, {
    LoginID,
    DeviceType: 1, //web
  });
}

export function healthCheck(refreshToken) {
  return post(POST_HealthCheck, {
    RefreshToken: refreshToken,
  });
}
